import { client } from "../client";
import { Earmold, Variant } from "../types/earmold.types";

export const createEarmold = async (earmold: Partial<Earmold>) => {
	const response = await client.post<Earmold>(`earmolds/`, earmold);
	return response.data;
};

export const updateEarmold = async ({
	id,
	earmold,
}: {
	id: number | string | undefined;
	earmold: Partial<Earmold>;
}) => {
	if (id === undefined) {
		return null;
	}
	const response = await client.patch<Earmold>(`earmolds/${id}`, earmold);
	return response.data;
};

export const createEarmoldVariants = async ({
	id,
	variant,
}: {
	id: number | string | undefined;
	variant: Partial<Variant>;
}) => {
	if (id === undefined) {
		return null;
	}
	const response = await client.post<Earmold>(
		`earmolds/${id}/variants`,
		variant,
	);
	return response.data;
};
